<template>
  <div>
    <div class="geekVideo">
      <div class="videoLeft">
        <div class="videoStart">
          <ul>
            <li class="noscale" v-for="item in homeVideolist" :key="item.videoId">
              <router-link :to="'/video/detail?id='+item.videoId" target="_blank">
                <img :src="item.videoThumb | imageUrl('',550,310)">
                <div class="blackLayers"></div>
                <div class="blue"></div>
              </router-link>

              <div class="geekPersonal">
                <router-link
                  class="spaned"
                  style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                  :to="'/video/detail?id='+item.videoId"
                >{{item.videoTitle}}</router-link>
                <div class="geekHead">
                  <router-link :to="`/peopleCenter/`+item.userId">
                    <a class="geekheadSmall" href>
                      <img :src="item.userAvatar | imageUrl('/static/profile_img_default.png',40,40)" alt>
                    </a>
                    <span>
                      <a>{{item.userNickname}}</a>
                    </span>
                  </router-link>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div
          class="number search-number yyu"
          style="margin:0;margin-top: 15px;margin-bottom: -15px;"
        ></div>
      </div>
    </div>
    <pages
      :page-size="pagerParam.pageSize"
      :page-count="pagerParam.pageCount"
      :current-page.sync="pagerParam.currentPage"
      :total="pagerParam.total"
      @current-page-changed="OnCurrentPageChanged"
    ></pages>
  </div>
</template>

<script>
import "./css/lifePz.css";
import pages from "../../components/pages.vue";

export default {
  name: "IndexPage",
  metaInfo() {
    return {
      title: this.$t("global.入围作品") + " | MANA"
    };
  },
  components: {
    pages
  },
  data() {
    return {
      contestName: null,
      homeVideolist: [],
      pagerParam: {
        pageSize: 21,
        pageCount: 1,
        currentPage: 1,
        total: 0
      },
      matchObject: {}
    };
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      this.contestName = this.$route.params.contestName;
      if (this.contestName) {
        this.$http
          .get("/api/nmatch/url/" + this.contestName)
          .then(response => {
            this.matchObject = response.data;
            this.gethomeVideolist();
          });
      }
    },
    gethomeVideolist() {
      let $this = this;
      this.$http
        .get("/api/match/video/list", {
          params: {
            pageIndex: this.pagerParam.currentPage,
            pageSize: this.pagerParam.pageSize,
            matchId: this.matchObject.id,
            status: 5
          }
        })
        .then(function(response) {
          $this.homeVideolist = response.data.list;
          $this.pagerParam = {
            pageSize: response.data.pageSize,
            pageCount: response.data.totalPage,
            currentPage: response.data.pageIndex,
            total: response.data.totalRecord
          };
        });
    },

    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.gethomeVideolist();
    }
  }
};
</script>
<style scoped>
.videoStart {
  border: none;
  min-height: calc(100vh - 745px);
}
</style>



// WEBPACK FOOTER //
// src/pages/match/shortlistedEntries.vue